var map = {
	"./educatorApp/auth": 44518,
	"./educatorApp/auth.ts": 44518,
	"./educatorApp/demo": 63839,
	"./educatorApp/demo.ts": 63839,
	"./educatorApp/dev": 28541,
	"./educatorApp/dev-next": 20003,
	"./educatorApp/dev-next.ts": 20003,
	"./educatorApp/dev.ts": 28541,
	"./educatorApp/production": 78691,
	"./educatorApp/production.ts": 78691,
	"./educatorApp/qa01": 70381,
	"./educatorApp/qa01.ts": 70381,
	"./educatorApp/stage": 61124,
	"./educatorApp/stage.ts": 61124,
	"./studentApp/demo": 94037,
	"./studentApp/demo.ts": 94037,
	"./studentApp/dev": 22775,
	"./studentApp/dev-next": 10469,
	"./studentApp/dev-next.ts": 10469,
	"./studentApp/dev.ts": 22775,
	"./studentApp/production": 90929,
	"./studentApp/production.ts": 90929,
	"./studentApp/qa01": 39391,
	"./studentApp/qa01.ts": 39391,
	"./studentApp/stage": 2370,
	"./studentApp/stage.ts": 2370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;